import React, { useState } from "react";
import { useTheme } from "@emotion/react";
import ImageButton from "@components/button/ImageButton";
import i18n from "i18next";
import BasicDrawer from "@components/drawer/BasicDrawer";
import Image from "@components/item/Image";
import styled from "@emotion/styled";

const LanguageItem = styled.button<{ isLast: boolean; focus: boolean }>(
  ({ theme, isLast, focus }) => ({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "0.4rem",
    fontSize: "1.6rem",
    fontWeight: theme.fontWeight.medium,
    color: focus ? theme.color.green : theme.color.black,
    lineHeight: "1.6rem",
    cursor: "pointer",
    padding: "2rem 0",
    borderBottom: isLast ? "none" : `1px solid ${theme.color.border_gray}`,
    width: "100%",
  }),
);

const LanguageButton = () => {
  const [openDrawer, setOpenDrawer] = useState(false);
  const theme = useTheme();
  const currentLang = window.localStorage.getItem("language") || "ko";

  const languageList = [
    { code: "ko", label: "한국어" },
    { code: "en", label: "English" },
  ];

  const handleLanguageChange = (lang: string) => {
    if (lang === currentLang) {
      return;
    }

    i18n.changeLanguage(lang);
    window.localStorage.setItem("language", lang);
    setOpenDrawer(false);
    window.location.reload();
  };

  return (
    <>
      <ImageButton
        src={theme.image.language.default}
        width="28px"
        height="28px"
        onClick={() => setOpenDrawer(true)}
      />

      <BasicDrawer open={openDrawer} setOpen={setOpenDrawer}>
        {languageList.map((lang, index) => (
          <LanguageItem
            key={lang.code}
            focus={currentLang === lang.code}
            isLast={index === languageList.length - 1}
            onClick={() => handleLanguageChange(lang.code)}>
            <span>{lang.label}</span>
            {currentLang === lang.code && (
              <Image src={theme.image.check_green.default} />
            )}
          </LanguageItem>
        ))}
      </BasicDrawer>
    </>
  );
};

export default LanguageButton;
